module.exports = __webpack_public_path__ + "img/IMG_9033_L_Foamcore_MockedUp.11427904.jpg";